import React from 'react';
import { Calendar, Clock } from 'lucide-react';
import './ViewToggle.css';

export type ViewType = 'monthly' | 'cycle';

interface ViewToggleProps {
  viewType: ViewType;
  onViewChange: (viewType: ViewType) => void;
}

const ViewToggle: React.FC<ViewToggleProps> = ({ viewType, onViewChange }) => {
  return (
    <div className="view-toggle">
      <div className="view-toggle-header">
        <h3>Tipo de Vista</h3>
        <p>Selecciona cómo quieres ver los datos de uso</p>
      </div>
      
      <div className="view-toggle-options">
        <button
          className={`view-toggle-button monthly ${viewType === 'monthly' ? 'active' : ''}`}
          onClick={() => onViewChange('monthly')}
        >
          <Calendar size={20} />
          <div className="view-toggle-content">
            <span className="view-toggle-title">Por Mes</span>
            <span className="view-toggle-description">
              Datos del mes calendario completo
            </span>
          </div>
        </button>

        <button
          className={`view-toggle-button cycle ${viewType === 'cycle' ? 'active' : ''}`}
          onClick={() => onViewChange('cycle')}
        >
          <Clock size={20} />
          <div className="view-toggle-content">
            <span className="view-toggle-title">Por Ciclo</span>
            <span className="view-toggle-description">
              Datos desde la fecha de inicio de cada cliente
            </span>
          </div>
        </button>
      </div>
    </div>
  );
};

export default ViewToggle;
